import { render, staticRenderFns } from "./customer-area-setting-page.vue?vue&type=template&id=2045544f&"
import script from "./customer-area-setting-page.vue?vue&type=script&lang=ts&"
export * from "./customer-area-setting-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports